import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./OrderResultModal.css";

const OrderResultModal = ({ isOpen, resultData, onClose }) => {
  if (!isOpen || !resultData) {
    return null;
  }

  const { data } = resultData;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      centered
      className="order-result-modal"
    >
      <Modal.Header
        closeButton
        className="order-result-modal-header"
        style={{
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          borderBottom: "none",
          padding: "2rem",
        }}
      >
        <div className="order-result-header" style={{ width: "100%" }}>
          <div className="order-result-icon success-icon">
            <i className="fa fa-check-circle"></i>
          </div>
          <h4
            className="order-result-title"
            style={{
              margin: 0,
              flex: 1,
              wordWrap: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {data.message || "Órdenes creadas exitosamente."}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body className="order-result-modal-body">
        <div className="order-result-content">
          {/* Estadísticas principales */}
          <div className="order-result-stats">
            <div className="stat-card stat-total">
              <div className="stat-icon">
                <i className="fa fa-list-ol"></i>
              </div>
              <div className="stat-info">
                <div className="stat-label">Total Solicitadas</div>
                <div className="stat-value">{data.totalSolicitadas}</div>
              </div>
            </div>

            <div className="stat-card stat-created">
              <div className="stat-icon">
                <i className="fa fa-check"></i>
              </div>
              <div className="stat-info">
                <div className="stat-label">Total Creadas</div>
                <div className="stat-value">{data.totalCreadas}</div>
              </div>
            </div>
          </div>

          {/* Folios creados */}
          {data.foliosCreados && data.foliosCreados.length > 0 && (
            <div className="order-result-section folios-created-section">
              <div className="section-header">
                <div className="section-icon create-icon">
                  <i className="fa fa-plus-circle"></i>
                </div>
                <h6 className="section-title">
                  Folios Creados{" "}
                  <span className="badge-count">
                    {data.foliosCreados.length}
                  </span>
                </h6>
              </div>
              <div className="folios-list">
                {data.foliosCreados.map((folio, index) => (
                  <div key={index} className="folio-item folio-success">
                    <i className="fa fa-check-circle"></i>
                    <span>{folio}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Folios ya existentes */}
          {data.foliosYaExistentes && data.foliosYaExistentes.length > 0 && (
            <div className="order-result-section folios-existing-section">
              <div className="section-header">
                <div className="section-icon warning-icon">
                  <i className="fa fa-exclamation-triangle"></i>
                </div>
                <h6 className="section-title">
                  Folios Ya Existentes{" "}
                  <span className="badge-count">
                    {data.foliosYaExistentes.length}
                  </span>
                </h6>
              </div>
              <div className="folios-list">
                {data.foliosYaExistentes.map((folio, index) => (
                  <div key={index} className="folio-item folio-warning">
                    <i className="fa fa-exclamation-circle"></i>
                    <span>{folio}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderResultModal;
